import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14723662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "camera_list_wrap" }
const _hoisted_2 = { class: "camera_list" }
const _hoisted_3 = {
  key: 0,
  class: "camera_check"
}
const _hoisted_4 = { class: "camera_list_thumb" }
const _hoisted_5 = { class: "camera_list_desc" }
const _hoisted_6 = { class: "camera_list_name link_text" }
const _hoisted_7 = { class: "error_icon" }
const _hoisted_8 = { class: "camera_list_info" }
const _hoisted_9 = { class: "flex_box" }
const _hoisted_10 = { class: "tags" }
const _hoisted_11 = { class: "tool_tip_nav" }

import WhiteBox from '@/components/atoms/WhiteBox.vue'
import Thumbnail from '@/components/atoms/Thumbnail.vue'
import Icon from '@/components/atoms/Icon.vue'
import Tag from '@/components/atoms/Tag.vue'
import EventIcons from '@/components/molecules/EventIcons.vue'
import ToolTipButton from '@/components/organisms/ToolTipButton.vue'
import IconText from '@/components/molecules/IconText.vue'
import SimpleCheckbox from '@/components/atoms/SimpleCheckbox.vue'
import { getIcons } from '@/js/utils/util'
import { computed, withDefaults } from 'vue'
import { Camera } from '@/@types/typescript-axios/api'
import VueI18n from 'vue-i18n'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

type PropsType = {
  cameraData: Camera
  toggleTagBtnFlag?: boolean
  displayCheckBox?: boolean
  checked?: boolean
  listType?: string
  downCameraCondition?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraListRow',
  props: {
    cameraData: null,
    toggleTagBtnFlag: { type: Boolean, default: false },
    displayCheckBox: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
    listType: null,
    downCameraCondition: { type: Boolean, default: false }
  },
  emits: ["update:checked", "showCameraInfoDialog", "openMap", "setTag"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:checked', value: boolean): void
  (e: 'showCameraInfoDialog', value: string | undefined): void
  (e: 'openMap', value: Camera): void
  (e: 'setTag', value: Camera): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { cameraData: Camera, toggleTagBtnFlag: boolean, displayCheckBox: boolean, checked: boolean, listType?: string, downCameraCondition: boolean };

const store = useStore()
const router = useRouter()





const checkedCamera = computed({
  get: () => props.checked,
  set: (value) => {
    emit('update:checked', value)
  },
})

const eventIcons = computed<{ icon: string; text: VueI18n.TranslateResult }[]>(() => {
  return getIcons(props.cameraData, store.getters['app/environmentMode'])
})

const displayMapNav = computed<boolean>(() => props.listType === 'cameras')
const watchStatusIconShow = computed<boolean>(() => {
  return props.cameraData.watch_status === 'down'
})
const linkParams = computed(() => ({
  name: 'detail',
  params: { code: props.cameraData.camera_code },
}))

/**
 * 人数カウント権限
 */
const canPeopleCounter = computed<boolean>(
  () => store.getters['auth/permissions/analytics'] && props.cameraData.use_people_counter
)

/**
 * 人数カウントを表示
 */
const showPeopleCounter = () => {
  router.push({
    name: 'camera_people_counter',
    params: { code: props.cameraData.camera_code },
  })
}
/**
 * カメラ詳細情報ダイアログを表示
 */
const showCameraInfoDialog = () => {
  emit('showCameraInfoDialog', props.cameraData.camera_code)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WhiteBox, { padding: 8 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (__props.displayCheckBox)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(SimpleCheckbox, {
                  modelValue: _unref(checkedCamera),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checkedCamera) ? (checkedCamera).value = $event : null))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: _unref(linkParams) }, {
              default: _withCtx(() => [
                _createVNode(Thumbnail, {
                  src: __props.cameraData.thumb_url,
                  width: "100%"
                }, null, 8, ["src"])
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: _unref(linkParams) }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_6, [
                  _withDirectives(_createElementVNode("span", _hoisted_7, [
                    _createVNode(Icon, {
                      type: "error_outline",
                      color: "color-red"
                    })
                  ], 512), [
                    [_vShow, _unref(watchStatusIconShow)]
                  ]),
                  _createTextVNode(_toDisplayString(__props.cameraData.camera_name), 1)
                ])
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", null, [
                _createVNode(Icon, {
                  type: "videocam",
                  color: "color-dark2",
                  size: "16"
                }),
                _createElementVNode("span", null, _toDisplayString(__props.cameraData.location_name), 1)
              ]),
              _createElementVNode("li", null, [
                _createVNode(Icon, {
                  type: "room",
                  color: "color-dark2",
                  size: "16"
                }),
                _createElementVNode("span", null, _toDisplayString(__props.cameraData.location_address), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cameraData.tags, (tag) => {
                  return (_openBlock(), _createBlock(Tag, {
                    text: tag.tag_name,
                    key: tag.tag_code,
                    class: "tag"
                  }, null, 8, ["text"]))
                }), 128)),
                _createVNode(EventIcons, { icons: _unref(eventIcons) }, null, 8, ["icons"])
              ])
            ])
          ]),
          _createVNode(ToolTipButton, {
            icon: "more_vert",
            useCircle: true,
            bgColor: "gray",
            useBorder: false,
            position: "left",
            width: "250px",
            "data-test": "camera-list-row-tool-tip-button"
          }, {
            default: _withCtx(() => [
              _createElementVNode("nav", _hoisted_11, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: _unref(linkParams) }, {
                      default: _withCtx(() => [
                        _createVNode(IconText, {
                          icon: "play_circle_outline",
                          color: "color-white"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('camera_list_row.video')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _withDirectives(_createElementVNode("li", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('openMap', __props.cameraData)))
                  }, [
                    _createVNode(IconText, {
                      icon: "room",
                      color: "color-white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('camera_list_row.show_map')), 1)
                      ]),
                      _: 1
                    })
                  ], 512), [
                    [_vShow, _unref(displayMapNav)]
                  ]),
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('setTag', __props.cameraData))),
                    "data-test": "camera-list-row-set-tag-dialog"
                  }, [
                    _createVNode(IconText, {
                      icon: "label",
                      color: "color-white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('camera_list_row.select_tag')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", {
                    onClick: showCameraInfoDialog,
                    "data-test": "camera-list-row-information-dialog"
                  }, [
                    _createVNode(IconText, {
                      icon: "info",
                      color: "color-white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('camera_list_row.information')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  (_unref(canPeopleCounter))
                    ? (_openBlock(), _createElementBlock("li", {
                        key: 0,
                        onClick: showPeopleCounter
                      }, [
                        _createVNode(IconText, {
                          icon: "people",
                          color: "color-white"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('camera_list_row.people_counter')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})